import {courseApi, classesApi, scheduleApi, userApi} from '@/api';
import {message} from 'ant-design-vue';

export const editScheduleRoutineSettingApi = (data: any): Promise<null | {data: any}> => {
    return new Promise(resolve => {
        scheduleApi.editScheduleRoutineSetting({
            data,
            success: (res: any) => {
                if (res.code !== 0) {
                    message.error('操作失败！');
                    return resolve(null);
                }
                resolve(res);
            },
            error: () => {
                message.error('操作失败！');
                resolve(null);
            }
        });
    });
};

export const editScheduleApi = (data: any): Promise<null | {data: any; code: number}> => {
    return new Promise(resolve => {
        scheduleApi.editSchedule({
            data,
            success: (res: any) => {
                if (res.code !== 0) {
                    message.error('排课失败！');
                    return resolve(null);
                }
                resolve(res);
            },
            error: (err: any) => {
                if (err && err.response && err.response.status === 409) {
                    return resolve(err.response.data);
                }
                console.info(111, err);
                message.error('排课失败！');
                resolve(null);
            }
        });
    });
};

export const addScheduleApi = (data: any): Promise<null | {data: any}> => {
    return new Promise(resolve => {
        scheduleApi.addSchedule({
            data,
            success: (res: any) => {
                if (res.code !== 0) {
                    message.error('排课失败！');
                    return resolve(null);
                }
                resolve(res);
            },
            error: () => {
                message.error('排课失败！');
                resolve(null);
            }
        });
    });
};

export const deleteScheduleApi = (data: any): Promise<null | {data: any}> => {
    return new Promise(resolve => {
        scheduleApi.deleteSchedule({
            data,
            success: (res: any) => {
                if (res.code !== 0) {
                    message.error('删除失败！');
                    return resolve(null);
                }
                resolve(res);
            },
            error: () => {
                message.error('删除失败！');
                resolve(null);
            }
        });
    });
};

export const getDirByIdApi = (urlParams: any): Promise<null | {data: any}> => {
    return new Promise(resolve => {
        courseApi.getDirById({
            urlParams,
            success: (res: any) => {
                if (res.code !== 0) {
                    message.error('获取失败');
                    return resolve(null);
                }
                resolve(res);
            },
            error: () => {
                message.error('获取失败');
                resolve(null);
            }
        });
    });
};

export const getClassListApi = (urlQueryParmas: any, _this: any): Promise<null | {data: any}> => {
    return new Promise(resolve => {
        classesApi.getClassList({
            context: _this,
            pager: [],
            urlQueryParmas,
            afterRender: async (res: any) => {
                if (res.code !== 0) {
                    message.error('获取失败');
                    return resolve(null);
                }
                resolve(res);
            },
            error: () => {
                message.error('获取失败');
                resolve(null);
            }
        });
    });
};

export const getAllClassListApi = (urlQueryParmas: any, _this: any): Promise<null | {data: any}> => {
    return new Promise(resolve => {
        classesApi.getAllClassList({
            context: _this,
            pager: [],
            urlQueryParmas,
            success: async (res: any) => {
                if (res.code !== 0) {
                    message.error('获取失败');
                    return resolve(null);
                }
                resolve(res);
            },
            error: () => {
                message.error('获取失败');
                resolve(null);
            }
        });
    });
};

export const getTeacherByClassIdListApi = (urlQueryParmas: any, _this: any): Promise<null | {data: any}> => {
    return new Promise(resolve => {
        classesApi.getTeacherByClassIdList({
            context: _this,
            pager: [],
            urlQueryParmas,
            success: (res: any) => {
                if (res.code !== 0) {
                    message.error('获取失败');
                    return resolve(null);
                }
                resolve(res);
            },
            error: () => {
                message.error('获取失败');
                resolve(null);
            }
        });
    });
};

export const getScheduleListApi = (urlParams: any): Promise<null | {data: any}> => {
    return new Promise(resolve => {
        scheduleApi.getScheduleList({
            urlParams,
            success: (res: any) => {
                if (res.code !== 0) {
                    message.error('获取失败！');
                    return resolve(null);
                }
                resolve(res);
            },
            error: () => {
                message.error('获取失败');
                resolve(null);
            }
        });
    });
};

export const getScheduleRoutineSettingApi = (urlParams: any): Promise<null | {data: any}> => {
    return new Promise(resolve => {
        scheduleApi.getScheduleRoutineSetting({
            urlParams,
            success: (res: any) => {
                if (res.code !== 0) {
                    message.error('获取失败！');
                    return resolve(null);
                }
                resolve(res);
            },
            error: (err: {response: any}) => {
                if (err.response.status !== 404) {
                    message.error('获取失败');
                }
                resolve(null);
            }
        });
    });
};

export const getUserFindApi = (urlParams: any, _this: any): Promise<null | {data: any}> => {
    return new Promise(resolve => {
        userApi.getUserFindExtra({
            context: this,
            pager: [],
            urlParams,
            success: (res: any) => {
                if (res.code !== 0) {
                    message.error('获取失败！');
                    return resolve(null);
                }
                resolve(res);
            },
            error: () => {
                message.error('获取失败');
                resolve(null);
            }
        });
    });
};

export const exportScheduleApi = (urlParams: any, type: 'card' | 'list' = 'card'): Promise<null | Blob> => {
    return new Promise(resolve => {
        const api = type === 'card' ? scheduleApi.exportScheduleTable : scheduleApi.exportScheduleList;
        api({
            urlParams,
            success: (res: any) => {
                if (res.constructor.name === 'Blob') {
                    resolve(res);
                    return;
                }
                resolve(null);
                message.error('导出失败');
            },
            error: (res: any) => {
                if (res?.constructor?.name === 'Blob') {
                    resolve(res);
                    return;
                }
                resolve(null);
                message.error('导出失败');
            }
        });
    });
};
